import { useState } from "react";

import Welcome from "../startPage/welcome/Welcome";
import UserOptions from "../startPage/userOptions/UserOptions";
import Robotest from "../startPage/robo/Robotest";
import ServiceTerms from "../startPage/serviceTerms/ServiceTerms";
import ContactUs from "../startPage/contactUs/ContactUs";
import Guest from "./users/guest/Guest";
import NewUserSignup from "./users/newUser/NewUserSignup";
import RegisteredUserSignIn from "./users/registeredUser/RegisteredUserSignIn";
import PasswordRecoveryBase from "./users/registeredUser/PasswordRecoveryBase";

const Login = (props) => {
  const [displayWelcome, setDisplayWelcome] = useState(true);
  const [displayRobotest, setDisplayRobotest] = useState();
  const [displayUserOptions, setDisplayUserOptions] = useState();
  const [displayServiceTerms, setDisplayServiceTerms] = useState();
  const [emailPasswordResetHelp, setEmailPasswordResetHelp] = useState();
  const [usernamePasswordResetHelp, setUsernamePasswordResetHelp] = useState();
  const [phonePasswordResetHelp, setPhonePasswordResetHelp] = useState();     
  const [userOption, setUserOption] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState();

  const displayRoboTest = () => {
      setDisplayWelcome(false);
      setDisplayRobotest(true);
  };

  const userOptionHandler = option => {
      setUserOption(option);
      setDisplayUserOptions(false);
      setDisplayServiceTerms(true);
  };

  const displayUserOptionsHandler = () => {
      setDisplayRobotest(false);
      setDisplayUserOptions(true);
  };
  
  const serviceTermsAcceptanceHandler = accept => {
      accept ? setAcceptTerms(accept) : setUserOption();
  };
  
  const guestHandler = (callname) => {
      props.onGuestSubmission(callname);
  };

  const passwordResetCompletedHandler = () => {      
      setEmailPasswordResetHelp(false)
      setUsernamePasswordResetHelp(false)
      setPhonePasswordResetHelp(false)
  }

  const showUserOptionsHandler = () => {
      setDisplayRobotest(false);
      setDisplayServiceTerms(false);
      setUserOption();
      setDisplayUserOptions(true);
      setEmailPasswordResetHelp(false);
      setUsernamePasswordResetHelp(false);
      setPhonePasswordResetHelp(false);
  }

  const logoutConfirmedHandler = () => {
      setDisplayWelcome(true);
      setDisplayRobotest();
      setDisplayUserOptions();
      setUserOption();
      setDisplayServiceTerms();
      setAcceptTerms();
      setEmailPasswordResetHelp(false);
      setUsernamePasswordResetHelp(false);
      setPhonePasswordResetHelp(false);
      props.onLogout();
  };

  const restartLoginHandler = () => {
      alert(
          'Do you really want to sign out!!!', 
          'Click OK to sign out Click Cancel to stay on',
          [{
            text: 'Cancel',
            onPress: () => console.log('Cancel Pressed'),
            style: 'cancel',
          },
          {text: 'OK', onPress: logoutConfirmedHandler},
      ]);
  };

  const handleLoggedIn = (userData) => props.onLoggedIn(userData)

  return (
    <>
      {displayWelcome && <Welcome onDisplayRobotest={displayRoboTest} />}
      {displayRobotest && (
        <Robotest
          onRestart={restartLoginHandler}
          onRobotestCompleted={displayUserOptionsHandler}
        />
      )}
      {displayUserOptions && (
        <UserOptions
          onUserOption={userOptionHandler}
          onGoogleSignin={handleLoggedIn}
          onFacebookSignin={handleLoggedIn}
          onMicrosoftSignin={handleLoggedIn}
        />
      )}
      {userOption === "contact-us" && (
        <ContactUs
          onSubmit={showUserOptionsHandler}
          onCancel={showUserOptionsHandler}
        />
      )}
      {displayServiceTerms &&
        (userOption === "new-user" || userOption === "guest") &&
        !acceptTerms && (
          <ServiceTerms
            onAcceptTerms={serviceTermsAcceptanceHandler}
            onDecline={restartLoginHandler}
          />
        )}
      {userOption === "guest" && acceptTerms && (
        <Guest onSubmit={guestHandler} onCancel={showUserOptionsHandler} />
      )}
      {userOption === "registered-user" &&
        !emailPasswordResetHelp &&
        !usernamePasswordResetHelp &&
        !phonePasswordResetHelp && (
          <RegisteredUserSignIn
            onLoggedIn={handleLoggedIn}
            onEmailPasswordHelpRequest={() => setEmailPasswordResetHelp(true)}
            onUsernamePasswordHelpRequest={() =>
              setUsernamePasswordResetHelp(true)
            }
            onPhonePasswordHelpRequest={() => setPhonePasswordResetHelp(true)}
            onLogout={restartLoginHandler}
            onCancel={showUserOptionsHandler}
          />
        )}
      {userOption === "registered-user" && emailPasswordResetHelp && (
        <PasswordRecoveryBase
          type="email"
          label="Email"
          inputId="email"
          inputPlaceholder="Enter your email"
          inputMaxLength={72}
          emptyInputMessage="Enter your email"
          invalidUidMessage="Invalid email"
          onCompletion={passwordResetCompletedHandler}
          onCancel={showUserOptionsHandler}
        />
      )}
      {userOption === "registered-user" && usernamePasswordResetHelp && (
        <PasswordRecoveryBase
          type="username"
          label="Username"
          inputId="username"
          inputPlaceholder="Enter your username"
          inputMaxLength={15}
          emptyInputMessage="Enter your username"
          invalidUidMessage="Invalid username"
          onCompletion={passwordResetCompletedHandler}
          onCancel={showUserOptionsHandler}
        />
      )}
      {userOption === "registered-user" && phonePasswordResetHelp && (
        <PasswordRecoveryBase
          type="phone"
          label="Phone number"
          inputId="phone"
          inputPlaceholder="Enter your phone (+123...)"
          inputMaxLength={18}
          emptyInputMessage="Enter valid phone with country code"
          invalidUidMessage="Invalid phone number"
          onCompletion={passwordResetCompletedHandler}
          onCancel={showUserOptionsHandler}
        />
      )}
      {userOption === "new-user" &&
        acceptTerms &&
        !emailPasswordResetHelp &&
        !usernamePasswordResetHelp &&
        !phonePasswordResetHelp && (
          <NewUserSignup
            onLoggedIn={handleLoggedIn}
            onCancel={showUserOptionsHandler}
          />
        )}
    </>
  );
};

export default Login;